import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import path from 'path';
import moment from 'moment-timezone';
import { customAlphabet } from 'nanoid';
import Editor from '@tinymce/tinymce-vue';
import dropsLoader from '@/mixins/components/drops-loader';
import { guid } from '@/mixins/guid';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';
import fontColors from '@editor/droplets/_bubble-options/components/inline-text/font-colors.json';
import ticket from '../ticket.schema';

export default Vue.component('admin-support-ticket-create', {
  template: require('./template.html'),
  name: 'admin-support-ticket-create',
  computed: {
    ...mapGetters(['currentUser', 'websites']),
    allowed() {
      const sites = this.websites.map(site => site.tier);
      return sites.includes('Premium') || sites.includes('Starter');
    },
    colors() {
      const list = [];
      _.forEach(fontColors, (hex) => {
        list.push(hex, hex);
      });
      return list;
    },
  },
  mixins: [guid, uploader],
  props: ['tiny-mce'],
  components: {
    Editor,
    dropsLoader,
    uploadProgress,
  },
  data() {
    return {
      loading: false,
      uuid: 'create-ticket-editor',
      tinyLoader: false,
      hideTextEditor: false,
      messageError: false,
      subject: '',
      message: '',
      priorities: [
        'low',
        'normal',
        'high',
      ],
      priority: 'normal',
      created: false,
      newId: false,
    };
  },
  created() {
    this.hideTextEditor = false;
    this.tinyLoader = true;
    this.created = moment(moment.utc().format());
    this.newId = this.makeTicketId(this.created._d);
  },
  methods: {
    initEditor() {
      this.$tinymce = tinymce;
      this.tinyLoader = false;
    },
    uploadImage(cb) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      const self = this;
      input.onchange = async function onFileChange() {
        const file = this.files[0];
        const title = file.name;
        const filePath = `${self.newId}/${path.basename(title)}`;
        const progress = self.$refs.progress.$el;

        if (progress) {
          // move the progress component into the tinyMce image upload modal
          const modalContent = document.querySelectorAll('[id^=dialog-describe_] .tox-dialog__body-content .tox-form')[0];
          modalContent.insertBefore(progress, modalContent.firstChild);
        }

        const upload = await self.uploadFile({
          file: filePath,
          body: file,
          Bucket: process.env.S3_TICKET_ASSETS_BUCKET,
          ACL: 'public-read',
          bucketPath: '',
          copyToOwner: false,
        });

        cb(upload.Location, { title });
      };
      input.click();
    },
    async createTicket() {
      this.$validator.validateAll().then(async (result) => {
        this.messageError = false;
        if (this.message.replace(/\s/g, '') === '') {
          this.messageError = 'Message cannot be empty.';
          return;
        }
        if (result) {
          const notif = {
            type: 'success',
            message: 'Ticket created successfully! We will be in touch as soon as possible.',
          };
          this.loading = true;
          try {
            const user = this.currentUser;
            const newTicket = ticket({
              _id: this.newId,
              created: this.created._i,
              subject: this.subject,
              priority: this.priority,
              message: {
                _id: this.guid(),
                created: this.created._i,
                status: 'public',
                attachments: [],
                author: user._id,
                message: this.message,
                plainText: this.$tinymce.activeEditor.getContent({ format: 'text' }),
              },
            });
            await this.$lightning([{
              name: 'createSupportTicket',
              payload: { ticket: newTicket },
            }]);
            if (!user.tickets) {
              this.$store.dispatch('setGlobalValue', {
                item: this.currentUser,
                key: 'tickets',
                value: [],
              });
            }
            this.$store.dispatch('runStateFn', {
              fn() {
                user.tickets.splice(0, 0, newTicket);
              },
            });
            this.$emit('load-ticket', newTicket);
          } catch (e) {
            const message = e.message || e;
            notif.type = 'error';
            notif.message = message;
            this.$log.error(message);
          } finally {
            this.loading = false;
            this.$store.dispatch('addNotification', {
              id: this.guid(),
              type: notif.type,
              message: notif.message,
            });
          }
        }
      });
    },
    makeTicketId(date) {
      const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      const month = months[date.getMonth()];
      const day = (`0${date.getDate()}`).slice(-2);
      const year = date.getFullYear().toString().substr(-2);
      const randomId = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 7)();
      return `${day}${month}${year}-${randomId}`.toUpperCase();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/support/tickets/create/index.js